'use strict';

angular.module('esn.calendar')
  .component('calSubscribeCalendarMenuItem', {
    template: require('./subscribe-calendar-menu-item.pug')
  });
